import React from 'react';
import ReactDOM from "react-dom";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ConversationQuestionOptions from "./ConversationQuestionOptions";
const reactStringReplace = require('react-string-replace');
const parse = require('html-react-parser');




class ConversationMainQuestion extends React.Component{

    constructor(props) {
        super(props);
    }

    componentDidMount() {

        /*console.log(this.dialog.childNodes)
        console.log(this.dialog.childNodes[0].childNodes[1].childNodes[1].innerHTML)
        console.log({frau})
        this.dialog.childNodes[0].childNodes[1].childNodes[1].innerHTML = '<img src='+{frau}+' />';*/
    }

    render(){
       let i=1;

       const qOptions = this.props.frageOptions;
       const setResult = this.props.setResult;
       const setAdditionalResult = this.props.setAdditionalResult;


        if(this.props.frageTitle.length>2) {
            const dropText = parse(this.props.frageTitle[2],{
                replace: function(domNode) {
                    if (domNode.data == "SELECT") {
                        let dropbox = 'select_'+ i;
                        i=i+1;
                        return <ConversationQuestionOptions
                            name={dropbox}
                            qOptions={qOptions}
                            setResult={setResult}
                            setAdditionalResult={setAdditionalResult}/>
                    }
                }
            });

            return (
                <div className="questionName">
                    <div className="questionHeading centered">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></p>
                    </div>
                    <div className="questionConversation" ref={input => { this.dialog = input; }}>
                        {dropText}
                    </div>
                </div>
            );
        }else{
            const dropText = parse(this.props.frageTitle[1],{
                replace: function(domNode) {
                    if (domNode.data == "SELECT") {
                        let dropbox = 'select_'+ i;
                        i=i+1;
                        return <ConversationQuestionOptions
                            name={dropbox}
                            qOptions={qOptions}
                            setResult={setResult}
                            setAdditionalResult={setAdditionalResult}/>
                    }
                }
            });
            return (
                <div className="questionName">
                    <div className="questionHeading centered">
                        <p dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></p>
                    </div>
                    <div className="questionConversation">
                        {dropText}
                    </div>
                </div>
            );
        }
    }


}
export default ConversationMainQuestion;
